<!-- manage-payment-methods-dialog.component.html -->

<h2 mat-dialog-title>Manage Bank Accounts</h2>
<mat-dialog-content>
  <!-- Top Section: Current Accounts -->
  <mat-nav-list>
    @for (b of accounts; track b) {
      <mat-list-item>
        <div class="account-row">
          <span class="account-label">
            {{ b.bankName }} ••••{{ ('' + b.AccountNumber).slice(-4) }}
          </span>
          <button
            mat-flat-button
            color="primary"
            class="remove-link"
            (click)="confirmRemove(b)"
          >Remove</button>
        </div>
      </mat-list-item>
    }
  </mat-nav-list>

  <!-- Remove Confirmation Dialog -->
  <ng-template #removeConfirm>
    <h2 mat-dialog-title>Remove Bank Account?</h2>
    <mat-dialog-content>
      <p>Are you sure you want to remove this account?</p>
      <p class="acct-name">
        {{ accountToRemove?.bankName }} {{ ('' + accountToRemove?.AccountNumber).slice(-4) }}
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button
        (click)="closeRemove()"
        [disabled]="isDeleting">
        No, keep it
      </button>

      <button mat-raised-button
        color="warn"
        (click)="removeAccount()"
        [disabled]="isDeleting">
        @if (isDeleting) {
          <mat-progress-spinner
            mode="indeterminate"
            diameter="20">
          </mat-progress-spinner>
        }
        <span>{{ isDeleting ? 'Removing…' : 'Yes, remove' }}</span>
      </button>
    </mat-dialog-actions>
  </ng-template>

  <!-- Middle Section: Add New -->
  <section class="add-new-section">
    <h3>Add a New Bank Account</h3>
    <form [formGroup]="addForm" class="add-new-form">

      <!-- 1) Routing Number: full‑width -->
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Routing Number</mat-label>
        <input
          matInput
          formControlName="routingNumber"
          required
          maxlength="9"
          pattern="\d*"
          inputmode="numeric"
          />
        @if (addForm.get('routingNumber')?.hasError('required')) {
          <mat-error>
            Routing Number is required
          </mat-error>
        }
        @if (addForm.get('routingNumber')?.hasError('pattern')) {
          <mat-error>
            Must be 9 digits
          </mat-error>
        }
      </mat-form-field>

      <!-- 2) Account Number: full‑width -->
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Account Number</mat-label>
        <input matInput formControlName="accountNumber" required />
        @if (addForm.get('accountNumber')?.hasError('required')) {
          <mat-error>
            Account Number is required
          </mat-error>
        }
      </mat-form-field>

      <!-- 3) Confirm & Type: two‑column row -->
      <div class="two-column">
        <mat-form-field appearance="fill" class="flex-item">
          <mat-label>Confirm Account Number</mat-label>
          <input matInput formControlName="confirmAccountNumber" required />
          @if (addForm.get('confirmAccountNumber')?.hasError('required')) {
            <mat-error>
              Confirmation is required
            </mat-error>
          }
          @if (addForm.hasError('mismatch')) {
            <mat-error>
              Account numbers do not match
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill" class="flex-item">
          <mat-label>Account Type</mat-label>
          <mat-select formControlName="accountType" required>
            <mat-option [value]="'checking'">Checking</mat-option>
            <mat-option [value]="'savings'">Savings</mat-option>
          </mat-select>
          @if (addForm.get('accountType')?.hasError('required')) {
            <mat-error>
              Account Type is required
            </mat-error>
          }
        </mat-form-field>
      </div>

      <!-- 4) Nickname: full‑width -->
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Bank Nickname</mat-label>
        <input matInput formControlName="nickname" />
      </mat-form-field>

    </form>
  </section>

</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-raised-button
    color="primary"
    [disabled]="addForm.invalid || isSaving"
    (click)="save()">
    @if (!isSaving) {
      <mat-icon>save</mat-icon>
    }
    @if (isSaving) {
      <mat-progress-spinner
        mode="indeterminate"
        diameter="20">
      </mat-progress-spinner>
    }
    <span>{{ isSaving ? 'Saving…' : 'Save' }}</span>
  </button>

</mat-dialog-actions>
